import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import EntitySelect from "../../../../../../components/EntitySelect";

export default function NewAssetView({
  settings,
  activeProjects,
  loadingProjects,
  creatingAsset,
  selectedProjectId,
  onSelectProject,
  onOpenCreateProject,
  quantity,
  onQuantityChange,
}) {
  return (
    <Box mt={2} mb={2}>
      <Typography align="center" mt={2} mb={4} fontSize={18}>
        Select the {String(settings.filter_field2 || "customer").toLowerCase()} this item belongs to.
        <br />
        You&apos;ll finish setting up item details in the next step.
      </Typography>
      <EntitySelect
        label={`Select ${settings.filter_field2}`}
        value={selectedProjectId}
        suggestions={activeProjects}
        disabled={loadingProjects || creatingAsset}
        onChange={project => onSelectProject(project?.id)}
        onAddNew={onOpenCreateProject}
        addNewLabel={`Add New ${settings.filter_field2}`}
      />
      <TextField
        label="Quantity in Location"
        type="number"
        value={quantity}
        onChange={e => {
          const v = e.target.value;
          onQuantityChange?.(v === "" ? 0 : Math.max(0, parseInt(v, 10) || 0));
        }}
        inputProps={{ min: 1, step: 1 }}
        fullWidth
        size="small"
        variant="outlined"
        sx={{ mt: 2 }}
        disabled={loadingProjects || creatingAsset}
      />
      {creatingAsset && (
        <Box mt={3} display="flex" justifyContent="center" alignItems="center" gap={1}>
          <CircularProgress size={44} />
        </Box>
      )}
    </Box>
  );
}
